export { ClaimFulfillmentFooter } from './claim-fulfillment-footer'
